import { ThemeEvents } from '@theme/events';
import { morph } from '@theme/morph';

document.addEventListener(ThemeEvents.variantUpdate, (event) => {
  const productId = event.detail?.data?.productId;
  const nextHtml = event.detail?.data?.html;

  if (!productId || !nextHtml) return;

  const targetSurface = event.target instanceof HTMLElement ? event.target.closest('.shopify-section, dialog') : null;
  const currentBlocks = targetSurface?.querySelectorAll(`.buy-buttons-block[data-bcn-product-id="${productId}"]`) ?? [];
  const nextBlocks = Array.from(nextHtml.querySelectorAll('.buy-buttons-block[data-bcn-buy-buttons-block-id]'));

  currentBlocks.forEach((currentBlock) => {
    const blockId = currentBlock.dataset.bcnBuyButtonsBlockId;
    const nextBlock = nextBlocks.find((candidate) => candidate.dataset.bcnBuyButtonsBlockId === blockId);

    if (!nextBlock) return;

    morph(currentBlock, nextBlock);
  });
});
